import { z } from 'zod';
import { REGISTRO_TIPOS, REGISTRO_STATUSES } from '../enums.js';
import { SYNC_BATCH_SIZE, MAX_FOTO_BASE64_CHARS } from '../constants.js';
const Lat = z.number().min(-90).max(90);
const Lng = z.number().min(-180).max(180);
// id e gerado no cliente (UUID v4) — garante idempotencia no sync offline.
export const RegistrarPontoSchema = z.object({
    id: z.string().uuid(),
    tipo: z.enum(REGISTRO_TIPOS),
    timestampDevice: z.string().datetime({ offset: true }),
    latitude: Lat.optional(),
    longitude: Lng.optional(),
    accuracyMetros: z.number().min(0).max(10_000).optional(),
    // ~300KB de string base64 (≈225KB de JPEG real)
    fotoCapturadaBase64: z.string().max(MAX_FOTO_BASE64_CHARS).optional(),
    biometriaScore: z.number().min(0).max(1).optional(),
    biometriaModelo: z.string().max(200).optional(),
    justificativa: z.string().max(500).optional(),
});
// Contrato POST /ponto/sync — nowDevice vem no envelope (nao por registro)
// e permite detectar skew de relogio do device no momento do envio.
export const SyncRequestSchema = z.object({
    registros: z.array(RegistrarPontoSchema).min(1).max(SYNC_BATCH_SIZE),
    nowDevice: z.string().datetime({ offset: true }),
});
// Alias legado (pre-nowDevice). Preferir SyncRequestSchema.
export const SyncBatchSchema = SyncRequestSchema;
export const SyncResultadoRegistroSchema = z.object({
    id: z.string().min(1),
    status: z.enum(REGISTRO_STATUSES),
    motivoStatus: z.string().nullable().optional(),
    dentroGeofence: z.boolean().nullable().optional(),
    distanciaMetros: z.number().int().nullable().optional(),
    biometriaVerificadaServidor: z.boolean(),
    biometriaScoreServidor: z.number().nullable().optional(),
});
export const SyncResponseSchema = z.object({
    resultados: z.array(z.object({
        id: z.string().uuid(), // uuid gerado no device
        resultado: z.enum(['ok', 'duplicado', 'erro']),
        motivo: z.string().optional(),
        registro: SyncResultadoRegistroSchema.optional(),
    })),
});
export const ListarPontosQuerySchema = z.object({
    funcionarioId: z.string().min(1).optional(),
    secretariaId: z.string().min(1).optional(),
    // busca textual por nome/matricula do funcionario (apenas escopo USER)
    q: z.string().min(1).optional(),
    tipo: z.enum(REGISTRO_TIPOS).optional(),
    dataInicio: z.string().datetime({ offset: true }).optional(),
    dataFim: z.string().datetime({ offset: true }).optional(),
    status: z.enum(REGISTRO_STATUSES).optional(),
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(200).default(50),
});
export const AprovarPontoSchema = z
    .object({
    status: z.enum(['validado', 'rejeitado', 'ajustado']),
    motivoStatus: z.string().max(500).optional(),
    ajusteTimestamp: z.string().datetime({ offset: true }).optional(),
})
    .superRefine((data, ctx) => {
    if (data.status === 'rejeitado' && !data.motivoStatus) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['motivoStatus'],
            message: 'motivoStatus e obrigatorio ao rejeitar',
        });
    }
    if (data.status === 'ajustado' && !data.ajusteTimestamp) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['ajusteTimestamp'],
            message: 'ajusteTimestamp e obrigatorio ao ajustar',
        });
    }
});
//# sourceMappingURL=ponto.js.map